import { base } from '../base';


async function getListOrder(param) {
  return base.get('services/purchase-order', param)
}

async function addNew(data) {
  return base.post('services/purchase-order', data)
}

async function update(data) {
  return base.put('services/purchase-order', data)
}

async function getListNeedRevoke(param) {
  return base.get('stokers/dashboard/need-revoke-orders', param)
}

async function getOrderOverview(param) {
  return base.get('stokers/orders/count-summary', param)
}

async function updatePrintPO(data) {
  return base.put('services/po/update-print-count', data)
}

async function getOrderProcessed(param) {
  return base.get('telesales/orders-processed', param)
}

async function getOrderForSalesman(param) {
  return base.get('trademarks/orders-for-salesman', param)
}

async function updateNoteStocker(data) {
  return base.put('services/po/update-stocker-note', data)
}

async function getReturOrderPromotionDonation(param) {
  return base.get('accountants/services/process-discount-for-salesman/item-donation', param)
}

async function getReturOrderPromotionMoney(param) {
  return base.get('accountants/services/process-discount-for-salesman/money', param)
}

async function reCalculateOrder(data) {
  return base.post('stokers/services/recalculate-order', data)
}

async function reportFollowOrder(data) {
  return base.get('reports/purchase-order-detail', data)
}

async function reportFollowSummaryOrder(data) {
  return base.get('reports/purchase-order-summary', data)
}

async function poPrint(data){
  return base.post('services/po/print', data)
}


export const orderService = {
  addNew,
  getListOrder,
  update,
  getListNeedRevoke,
  getOrderOverview,
  updatePrintPO,
  getOrderProcessed,
  getOrderForSalesman,
  updateNoteStocker,
  getReturOrderPromotionDonation,
  getReturOrderPromotionMoney,
  reCalculateOrder,
  reportFollowOrder,
  reportFollowSummaryOrder,
  poPrint
}